<template>
  <div class="position-relative h-100 stihl-overlay-wrap">

    <slot />

    <div class="position-absolute overlay stihl-overlay" v-if="active">
      <the-spinner v-if="showSpinner" :class="spinnerClass" />
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import TheSpinner from './TheSpinner.vue';

export default defineComponent({
  name: 'TheOverlay',
  components: { TheSpinner },
  props: {
    active: { type: Boolean, default: true },
    showSpinner: { type: Boolean, default: true },
    spinnerClass: { type: String, default: null },
  },
});
</script>

<style scoped>
.overlay {
  inset: 0;
  z-index: 100;
  opacity: 0.85;
}
</style>
